<template>
    <v-col align-self="center">
        <h1 style="text-align: left;margin-bottom: 1em;">
            La Taxe Locale sur la Publicité Extérieure
        </h1>
        <p>
            La taxe locale sur les enseignes et publicités extérieures (TLPE) est un impôt instauré de façon facultative par la commune ou l'établissement public de coopération intercommunal (EPCI), sur le territoire desquels sont situés les dispositifs publicitaires.
        </p>
        <p>
            Elle est due par l'exploitant du dispositif publicitaire, le propriétaire ou celui dans l'intérêt duquel le dispositif est réalisé.
        </p>
        <p>
            Son montant varie selon les caractéristiques des supports publicitaires et la taille de la collectivité.
        </p>
        <p>
            Ce simulateur proposé par
            <a href="https://www.gopubconseil.fr" target="_blank" class="link">
                Go Pub Conseil
            </a>
            vous permet de réaliser une simulation de votre montant.
        </p>
        <p>
            Téléchargez le Cerfa de déclaration
            <a href="../../assets/documents/cerfa_15702-02.pdf" class="link" download>
                Cerfa n° 15702*02
            </a>
        </p>
    </v-col>
</template>
<script>
export default {
    name: 'default-text',
    components: {},
    mixins: [],
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {

    },
    methods: {},
}
</script>



// WEBPACK FOOTER //
// src/components/Simulateur/DefaultText.vue